module.exports = __webpack_public_path__ + "img/button_next.bbf224cc.svg";